import { Box, Grid2, styled } from "@mui/material";

export const StyledContentGrid = styled(Grid2)({
  overflowY: "auto",
  scrollbarWidth: "none",
  "&::-webkit-scrollbar": {
    display: "none",
  },
});

export const SidebarContainer = styled(Box)(({ theme: { spacing } }) => ({
  marginTop: spacing(3),
  position: "fixed",
  right: spacing(3),
  top: "103px",
  bottom: spacing(3),
  width: "366px",
  zIndex: 999,
}));
